import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DepartmentsComponent } from './departments.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: DepartmentsComponent,
        data: {
          title: "Fakultetlar",
          breadcrumb: "Fakultetlar"
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DepartmentsRoutingModule { }
